import { useRouteError } from "react-router-dom";
import {
  Box,
  Heading,
  Text,
  Button,
  Grid,
  VStack
} from '@chakra-ui/react';
import NavBar from "./components/NavBar";
import LineSection from "./components/lineSection";
export default function ErrorPage() {
  const error = useRouteError();

  return (
    <>
    <NavBar />
    <LineSection />
    <Box>
      <Grid
        minH="100vh" >
        <VStack
          spacing={1}
          justifyContent={'center'} >
          <Heading
            display="inline-block"
            as="h2"
            size="2xl"
            bgGradient="linear(to-r, teal.400, teal.600)"
            backgroundClip="text">
            404
          </Heading>
          <Text
            fontSize="18px"
            color={"white"}
            mt={3}
            mb={2}>
            {error.statusText || error.message}
          </Text>
          <Text
            color={'gray.50'}
            mb={6}>
            The page you&apos;re looking for does not seem to exist.
          </Text>

          <Button
            as={"a"}
            colorScheme="teal"
            bgGradient="linear(to-r, teal.400, teal.500, teal.600)"
            color="white"
            variant="solid"
            href="/">
            Go to Home
          </Button>
        </VStack>
      </Grid>
    </Box>
    </>
  );
}